import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import Cookies from "js-cookie";
import { Context } from "../../../../../utils/context";
import { postData, getData } from "../../../../../utils/api";

const Step_Three_New = ({ prevStep, nextStep }) => {
  const user_id = Cookies.get("seller_user_id") || "";
  const { IMG_URL } = useContext(Context);

  const [panPreview, setPanPreview] = useState("");
  const [gstPreview, setGstPreview] = useState("");
  const [passbookPreview, setPassbookPreview] = useState("");
  const [kycPreview, setKycPreview] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const imageFile = watch("pan_image");
  const imageFile1 = watch("gst_image");
  const imageFile2 = watch("kyc_photo");
  const imageFile3 = watch("passbook_photo");

  // Load saved bank details
  const getEditData = async () => {
    if (!user_id) return;

    try {
      const res = await getData(`/seller/seller-bank-detail/${user_id}`);
      if (res?.success && res.data?.seller_bank_detail) {
        const bank = res.data.seller_bank_detail;

        reset({
          pan_no: bank.pan_no || "",
          gst_no: bank.gst_no || "",
          acc_no: bank.acc_no || "",
          ifsc_code: bank.ifsc_code || "",
          benificary_name: bank.benificary_name || "",
          bank_city: bank.bank_city || "",
          bank_state: bank.bank_state || "",
          bank_name: bank.bank_name || "",
          bank_branch: bank.bank_branch || "",
          pan_image: bank.pan_image || "",
          gst_image: bank.gst_image || "",
          passbook_photo: bank.passbook_photo || "",
          kyc_photo: bank.kyc_photo || "",
        });

        // if (bank.pan_image) setPanPreview(IMG_URL + bank.pan_image);
        // if (bank.gst_image) setGstPreview(IMG_URL + bank.gst_image);
        // if (bank.passbook_photo)
        //   setPassbookPreview(IMG_URL + bank.passbook_photo);
        // if (bank.kyc_photo) setKycPreview(IMG_URL + bank.kyc_photo);
      }
    } catch (err) {
      console.log("No bank details yet");
    }
  };

  useEffect(() => {
    if (user_id) {
      getEditData();
    }
  }, [user_id]);

  // Update previews
  // useEffect(() => {
  //   if (imageFile?.[0]) setPanPreview(URL.createObjectURL(imageFile[0]));
  //   if (imageFile1?.[0]) setGstPreview(URL.createObjectURL(imageFile1[0]));
  //   if (imageFile2?.[0]) setKycPreview(URL.createObjectURL(imageFile2[0]));
  //   if (imageFile3?.[0]) setPassbookPreview(URL.createObjectURL(imageFile3[0]));
  // }, [imageFile, imageFile1, imageFile2, imageFile3]);

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("user_id", user_id);
    formData.append("pan_no", data.pan_no || "");
    formData.append("gst_no", data.gst_no || "");
    formData.append("acc_no", data.acc_no || "");
    formData.append("ifsc_code", data.ifsc_code || "");
    formData.append("benificary_name", data.benificary_name || "");
    formData.append("bank_city", data.bank_city || "");
    formData.append("bank_state", data.bank_state || "");
    formData.append("bank_name", data.bank_name || "");
    formData.append("bank_branch", data.bank_branch || "");

    if (data.pan_image?.[0]) formData.append("pan_image", data.pan_image[0]);
    if (data.gst_image?.[0]) formData.append("gst_image", data.gst_image[0]);
    if (data.kyc_photo?.[0]) formData.append("kyc_photo", data.kyc_photo[0]);
    if (data.passbook_photo?.[0])
      formData.append("passbook_photo", data.passbook_photo[0]);

    try {
      const res = await postData("/seller/add-three", formData);
      if (res?.success) {
        alert("Bank details saved successfully!");
        nextStep();
      } else {
        alert(res?.message || "Failed to save");
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <section className="personal-details-form userForm">
      <div className="details-form-holder">
        <div className="form-container">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="">
              {/* PAN Number */}
              <div className="row mb-3">
                <div className="col-lg-6 col-md-6">
                  <div className="field-bottom">
                    <Form.Label className="required form-field">
                      PAN Number
                      {/* <span className="req_star">*</span> */}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter PAN Number"
                      {...register("pan_no", {
                        // required: "PAN number is required",
                        pattern: {
                          value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                          message: "Invalid PAN number",
                        },
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.pan_no,
                        "is-valid": !errors?.pan_no && getValues("pan_no"),
                      })}
                    />
                    {errors.pan_no && (
                      <span className="text-danger">
                        {errors.pan_no.message}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-lg-6 col-md-9">
                  <div className="img_input_holder">
                    <div className="img_form_field">
                      <Form.Label className="required">
                        Pan Image Upload
                        {/* <span className="req_star">*</span> */}
                      </Form.Label>
                      <Form.Control
                        type="file"
                        accept=".jpg,.jpeg,.png"
                        {...register("pan_image", {
                          validate: async (value) => {
                            // if (!value || value.length === 0) {
                            //   return "Pan Image is required";
                            // }

                            if (typeof value === "string") return true;

                            const file = value[0];
                            // if (!file) {
                            //   return "Pan Image is required";
                            // }
                          },
                        })}
                      />
                      {errors.pan_image && (
                        <span className="text-danger">
                          {errors.pan_image.message}
                        </span>
                      )}
                    </div>

                    <div className="img_container">
                      <Row className="justify-content-center">
                        <Row className="justify-content-center">
                          <Form.Label>Image Preview</Form.Label>
                          {typeof getValues("pan_image") === "string" &&
                          getValues("pan_image") ? (
                            <img
                              src={IMG_URL + getValues("pan_image")}
                              alt="Preview"
                              style={{
                                width: "80px",
                                height: "80px",
                                aspectRatio: "1 / 1",
                                objectFit: "contain",
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                              }}
                            />
                          ) : (
                            imageFile?.length > 0 && (
                              <img
                                src={URL.createObjectURL(imageFile[0])}
                                alt="Preview"
                                style={{
                                  width: "80px",
                                  height: "80px",
                                  marginTop: "10px",
                                  aspectRatio: "1 / 1",
                                  objectFit: "contain",
                                  border: "1px solid #ccc",
                                  borderRadius: "5px",
                                }}
                              />
                            )
                          )}
                        </Row>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* GST Number */}
              <div className="row">
                <div className="col-lg-6 col-md-6">
                  <div className="field-bottom">
                    <Form.Label className="required form-field">
                      GST Number
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="GST No"
                      {...register("gst_no", {
                        pattern: {
                          value: /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/,
                          message: "Invalid GST number",
                        },
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.gst_no,
                        "is-valid": !errors?.gst_no && getValues("gst_no"),
                      })}
                    />
                    {errors.gst_no && (
                      <span className="text-danger">
                        {errors.gst_no.message}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-lg-6 col-md-9">
                  <div className="img_input_holder">
                    <div className="img_form_field mb-4">
                      <Form.Label>GST Image Upload</Form.Label>
                      <Form.Control
                        type="file"
                        accept=".jpg,.jpeg,.png"
                        {...register("gst_image", {
                          validate: async (value) => {
                            // if (!value || value.length === 0) {
                            //   return "GST Image is required";
                            // }

                            if (typeof value === "string") return true;

                            const file = value[0];
                            // if (!file) {
                            //   return "GST Image is required";
                            // }
                          },
                        })}
                      />
                      {errors.gst_image && (
                        <span className="text-danger">
                          {errors.gst_image.message}
                        </span>
                      )}
                    </div>

                    <div className="img_container">
                      {/* <Row className="justify-content-center">
                        <Form.Label>Image Preview</Form.Label>
                        {gstPreview ? (
                          <div className="image-preview-container">
                            <img
                              src={gstPreview}
                              alt="GST Preview"
                              className="image-preview"
                              style={{
                                width: "100px",
                                height: "70px",
                                objectFit: "cover",
                              }}
                            />
                          </div>
                        ) : (
                          <small className="text-muted">
                            No image uploaded
                          </small>
                        )}
                      </Row> */}
                      <Row className="justify-content-center">
                        <Form.Label>Image Preview</Form.Label>
                        {typeof getValues("gst_image") === "string" &&
                        getValues("gst_image") ? (
                          <img
                            src={IMG_URL + getValues("gst_image")}
                            alt="Preview"
                            style={{
                              width: "80px",
                              height: "80px",
                              aspectRatio: "1 / 1",
                              objectFit: "contain",
                              border: "1px solid #ccc",
                              borderRadius: "5px",
                            }}
                          />
                        ) : (
                          imageFile1?.length > 0 && (
                            <img
                              src={URL.createObjectURL(imageFile1[0])}
                              alt="Preview"
                              style={{
                                width: "80px",
                                height: "80px",
                                marginTop: "10px",
                                aspectRatio: "1 / 1",
                                objectFit: "contain",
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                              }}
                            />
                          )
                        )}
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* Bank Details */}
              <div className="row">
                <div className="col-md-6">
                  <div className="field-bottom">
                    <Form.Label className="required">
                      Account Number
                      {/* <span className="req_star">*</span> */}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Account Number"
                      {...register("acc_no", {
                        // required: "Account number is required",
                        pattern: {
                          value: /^\d{9,18}$/,
                          message: "Invalid Account number",
                        },
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.acc_no,
                        "is-valid": !errors?.acc_no && getValues("acc_no"),
                      })}
                    />
                    {errors.acc_no && (
                      <span className="text-danger">
                        {errors.acc_no.message}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="field-bottom">
                    <Form.Label className="required">
                      IFSC Code
                      {/* <span className="req_star">*</span> */}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter IFSC Code"
                      {...register("ifsc_code", {
                        // required: "IFSC Code is required",
                        pattern: {
                          value: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                          message: "Invalid IFSC Code",
                        },
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.ifsc_code,
                        "is-valid":
                          !errors?.ifsc_code && getValues("ifsc_code"),
                      })}
                    />
                    {errors.ifsc_code && (
                      <span className="text-danger">
                        {errors.ifsc_code.message}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="field-bottom">
                    <Form.Label className="required">
                      Beneficiary Name
                      {/* <span className="req_star">*</span> */}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Beneficiary Name"
                      {...register("benificary_name", {
                        // required: "Benificary Required",
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.benificary_name,
                      })}
                    />
                    {errors.benificary_name && (
                      <span className="text-danger">
                        {errors.benificary_name.message}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="field-bottom">
                    <Form.Label className="required">
                      Bank City
                      {/* <span className="req_star">*</span> */}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Bank City"
                      {...register("bank_city", {
                        // required: "Bank City Required",
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.bank_city,
                      })}
                    />
                    {errors.bank_city && (
                      <span className="text-danger">
                        {errors.bank_city.message}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="field-bottom">
                    <Form.Label className="required">
                      Bank State
                      {/* <span className="req_star">*</span> */}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Bank State"
                      {...register("bank_state", {
                        // required: "Bank State Required",
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.bank_state,
                      })}
                    />
                    {errors.bank_state && (
                      <span className="text-danger">
                        {errors.bank_state.message}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="field-bottom">
                    <Form.Label className="required">
                      Bank Name
                      {/* <span className="req_star">*</span> */}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Bank Name"
                      {...register("bank_name", {
                        // required: "Bank Name Required",
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.bank_name,
                      })}
                    />
                    {errors.bank_name && (
                      <span className="text-danger">
                        {errors.bank_name.message}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="field-bottom">
                    <Form.Label className="required">
                      Bank Branch
                      {/* <span className="req_star">*</span> */}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Bank Branch"
                      {...register("bank_branch", {
                        // required: "Bank Branch Required",
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.bank_branch,
                      })}
                    />
                    {errors.bank_branch && (
                      <span className="text-danger">
                        {errors.bank_branch.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              {/* Passbook & KYC */}
              <div className="row mt-4">
                <div className="col-lg-6 col-md-9">
                  <div className="img_input_holder">
                    <div className="img_form_field mb-3">
                      <Form.Label className="required">
                        Upload Passbook photo{" "}
                        {/* <span className="req_star">*</span> */}
                      </Form.Label>
                      <Form.Control
                        type="file"
                        accept=".jpg,.jpeg,.png"
                        {...register("passbook_photo", {
                          validate: async (value) => {
                            // if (!value || value.length === 0) {
                            //   return "Passbook Image is required";
                            // }

                            if (typeof value === "string") return true;

                            const file = value[0];
                            // if (!file) {
                            //   return "Passbook Image is required";
                            // }
                          },
                        })}
                      />
                      {errors.passbook_photo && (
                        <span className="text-danger">
                          {errors.passbook_photo.message}
                        </span>
                      )}
                    </div>
                    <div className="img_container">
                      <Row className="justify-content-center">
                        <Form.Label>Image Preview</Form.Label>
                        {typeof getValues("passbook_photo") === "string" &&
                        getValues("passbook_photo") ? (
                          <img
                            src={IMG_URL + getValues("passbook_photo")}
                            alt="Preview"
                            style={{
                              width: "80px",
                              height: "80px",
                              aspectRatio: "1 / 1",
                              objectFit: "contain",
                              border: "1px solid #ccc",
                              borderRadius: "5px",
                            }}
                          />
                        ) : (
                          imageFile3?.length > 0 && (
                            <img
                              src={URL.createObjectURL(imageFile3[0])}
                              alt="Preview"
                              style={{
                                width: "80px",
                                height: "80px",
                                marginTop: "10px",
                                aspectRatio: "1 / 1",
                                objectFit: "contain",
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                              }}
                            />
                          )
                        )}
                      </Row>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-9">
                  <div className="img_input_holder">
                    <div className="img_form_field">
                      <Form.Label className="required">
                        Upload KYC Doc (Aadhaar Card, Driving License, Passport){" "}
                        <span className="req_star">*</span>
                      </Form.Label>
                      <Form.Control
                        type="file"
                        accept=".jpg,.jpeg,.png"
                        {...register("kyc_photo", {
                          validate: async (value) => {
                            if (!value || value.length === 0) {
                              return "KYC Image is required";
                            }

                            if (typeof value === "string") return true;

                            const file = value[0];
                            if (!file) {
                              return "KYC Image is required";
                            }
                          },
                        })}
                      />
                      {errors.kyc_photo && (
                        <span className="text-danger">
                          {errors.kyc_photo.message}
                        </span>
                      )}
                    </div>
                    <div className="img_container">
                      <Row className="justify-content-center">
                        <Form.Label>Image Preview</Form.Label>
                        {typeof getValues("kyc_photo") === "string" &&
                        getValues("kyc_photo") ? (
                          <img
                            src={IMG_URL + getValues("kyc_photo")}
                            alt="Preview"
                            style={{
                              width: "80px",
                              height: "80px",
                              aspectRatio: "1 / 1",
                              objectFit: "contain",
                              border: "1px solid #ccc",
                              borderRadius: "5px",
                            }}
                          />
                        ) : (
                          imageFile2?.length > 0 && (
                            <img
                              src={URL.createObjectURL(imageFile2[0])}
                              alt="Preview"
                              style={{
                                width: "80px",
                                height: "80px",
                                marginTop: "10px",
                                aspectRatio: "1 / 1",
                                objectFit: "contain",
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                              }}
                            />
                          )
                        )}
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* Buttons */}
              <div className="text-start apply_now_btn">
                <div className="registerContinueMain">
                  <Button onClick={prevStep} className="back-btn me-3">
                    Back
                  </Button>
                  <Button type="submit" className="tabs-btn">
                    Next
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </section>
  );
};

export default Step_Three_New;
